import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InterpretationComponent } from './pages/interpretation/interpretation.component';
import { InterpretationService } from './interpretation.service';
import { SharedModule } from '../../shared/shared.module';
import { MaterialModule } from '../../shared/material.module';
import { RouterModule } from '@angular/router';
import { SystemComponent } from './components/system/system.component';
import { ViewPhotoComponent } from './components/view-photo/view-photo.component';
import { UploadPhotoComponent } from './components/upload-photo/upload-photo.component';
import { EditPhotoComponent } from '../../shared/components/edit-photo/edit-photo.component';
import { AddComponentCommentComponent } from './components/add-component-comment/add-component-comment.component';
import { ComponentCommentModalComponent } from './components/component-comment-modal/component-comment-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuditLogComponent } from './components/audit-log/audit-log.component';
import { ConditionPhotoComponent } from './components/condition-photo/condition-photo.component';
import { ConditionCommentModalComponent } from './components/condition-comment-modal/condition-comment-modal.component';
import { QuoteContainerComponent } from './components/quote-container/quote-container.component';
import { QuoteRowComponent } from './components/quote-row/quote-row.component';
import { AddRecommendationComponent } from './components/add-recommendation/add-recommendation.component';
import { QuoteService } from './quote-service.service';
import { EditRecommendationComponent } from './components/edit-recommendation/edit-recommendation.component';
import { SystemGraphComponent } from './components/system-graph/system-graph.component';
import { BarGraphService } from './bar-graph.service';
import { SendReportModalComponent } from './components/send-report-modal/send-report-modal.component';
import { AddRecipientComponent } from './components/add-recipient/add-recipient.component';
import { JobsiteCommentModalComponent } from './components/jobsite-comment-modal/jobsite-comment-modal.component';
import { InspectionCommentModalComponent } from './components/inspection-comment-modal/inspection-comment-modal.component';
import { InspectionAdditionalObservationComponent } from './components/inspection-additional-observation/inspection-additional-observation.component';
import { TemperatureInspectionComponent} from './components/temperature-inspection/temperature-inspection.component';
import {AttachTemperatureInspectionPopupComponent} from './components/attach-temperature-inspection-popup/attach-temperature-inspection-popup.component';
import { MultiplePhotoUploadComponent } from  './components/multiple-photo-upload/multiple-photo-upload.component';
import { ForecastInterpretationComponent } from './components/forecast-interpretation/forecast-interpretation.component';
import { ForecastInterpretationSettingsComponent } from './components/forecast-interpretation-settings/forecast-interpretation-settings.component';
import { ActionRecommendationRulesQuotesComponent } from '../Action-Recommendation/action-recommendation-attach-rules/action-recommendation-rule-quotes.component';
import { ActionRecommendationAttachRulesComponent } from '../Action-Recommendation/action-recommendation-attach-rules/action-recommendation-attach-rules.component';
import { UploadNoconditionPhotoComponent } from './upload-nocondition-photo/upload-nocondition-photo.component';
import { ViewCompartTypeCommentComponent } from './components/view-compart-type-comment/view-compart-type-comment.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ForecastResetComponent } from './components/forecast-reset/forecast-reset.component';
import { ForecastUnderCariageDetailComponent } from './components/forecast-undercariage-details/forecast-undercariage-detail.component';
import { ForecastUndercariageComponent } from './components/forecast-undercariage/forecast-undercariage.component';
import { UcPlannerComponent } from './components/uc-planner/uc-planner.component';
import { DisplaySettingsPopupComponent } from './components/uc-planner/SettingsPopup/display-settings-popup/display-settings-popup.component';
import { UcpActionRecommendationComponent } from './components/uc-planner/ucp-action-recommendation/ucp-action-recommendation.component';
import { SearchActionRecommnedationComponent } from './components/uc-planner/search-action-recommnedation/search-action-recommnedation.component';
import { ComponentImageHistoryComponent } from './components/component-image-history/component-image-history.component';
import { ComponentImageDisplayComponent } from './components/component-image-history/component-image-display/component-image-display.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ForecastSettingsAvgWearComponent } from './components/forecast-settings-avg-wear/forecast-settings-avg-wear.component';
import { ForecastConfigurarationComponent } from './components/forecast-settings-avg-wear/forecast-configuraration/forecast-configuraration.component';
import { ForecastSettingPopupComponent } from './components/uc-planner/forecast-setting-popup/forecast-setting-popup.component';
import { UcplannerNewComponent } from './components/uc-planner/ucplanner-new/ucplanner-new.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { ForecastSeasonalDatesComponent } from './components/forecast-seasonal-dates/forecast-seasonal-dates.component';
@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        MaterialModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatFormFieldModule,
        DragDropModule,
        AngularEditorModule,
    ],
    declarations: [
        InterpretationComponent,
        SystemComponent,
        ViewPhotoComponent,
        UploadPhotoComponent,
        AddComponentCommentComponent,
        ComponentCommentModalComponent,
        AuditLogComponent,
        ConditionPhotoComponent,
        ConditionCommentModalComponent,
        QuoteContainerComponent,
        QuoteRowComponent,
        AddRecommendationComponent,
        EditRecommendationComponent,
        SystemGraphComponent,
        SendReportModalComponent,
        AddRecipientComponent,
        JobsiteCommentModalComponent,
        InspectionCommentModalComponent,
        InspectionAdditionalObservationComponent,
        TemperatureInspectionComponent,
        AttachTemperatureInspectionPopupComponent,
        MultiplePhotoUploadComponent,
        ForecastInterpretationComponent,
        ForecastInterpretationSettingsComponent,
        ActionRecommendationAttachRulesComponent,
        ActionRecommendationRulesQuotesComponent,
        UploadNoconditionPhotoComponent,
        ViewCompartTypeCommentComponent,
        ForecastUndercariageComponent,
        ForecastUnderCariageDetailComponent,
        ForecastResetComponent,
        UcPlannerComponent,
        DisplaySettingsPopupComponent,
        UcpActionRecommendationComponent,
        SearchActionRecommnedationComponent,
        ComponentImageHistoryComponent,
        ComponentImageDisplayComponent,
        ForecastSettingsAvgWearComponent,
        ForecastConfigurarationComponent,
        ForecastSettingPopupComponent,
        UcplannerNewComponent,
        ForecastSeasonalDatesComponent
    ],
    providers: [
        InterpretationService,
        QuoteService
    ],
    exports: [
        ConditionPhotoComponent,
        UploadPhotoComponent,
        MultiplePhotoUploadComponent,
        ComponentImageHistoryComponent
    ]
})
export class InterpretationModule { }
